import { func, object } from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';

import ListView from 'ravenjs/components/ListView';
import { callFunc } from 'ravenjs/utils/actions';
import { get } from 'ravenjs/utils/lodash';

import { actions as uiActions, selectors as uiSelectors } from 'modules/ui';
import { selectors as userSelectors } from 'modules/user';
import { MODALS } from 'constants/modals';

import listSchema from './listSchema.json';
import Modal from '../Modal';

function RolePartnerModal(props) {
    const { closeModal, modal } = props;
    const partners = get(modal, 'data.partners', []);
    const [selected, setSelected] = useState({});

    const renderSelect = row => {
        const onChangeSelect = () => {
            if (selected.id === row.id) {
                setSelected({});
            } else {
                setSelected(row);
            }
        };

        return <input checked={selected.id === row.id} onChange={onChangeSelect} type="checkbox" />;
    };

    /* eslint-disable react/no-danger */
    const renderContent = () => (
        <ListView selectable={renderSelect} data={partners} schema={listSchema} />
    );

    const actions = [
        {
            onClick() {
                closeModal(MODALS.ROLE_PARTNER_MODAL);
            },
            text: 'Cancel',
            color: 'cancelButton',
        },
        {
            onClick() {
                const onSubmit = get(modal, 'data.onSubmit');
                callFunc(onSubmit, selected);
            },
            text: 'Select Partner',
            color: 'primary',
        },
    ];

    return (
        <Modal
            id={MODALS.ROLE_PARTNER_MODAL}
            actions={actions}
            content={renderContent()}
            open={get(modal, 'open', false)}
        />
    );
}

RolePartnerModal.propTypes = {
    closeModal: func.isRequired,
    modal: object.isRequired,
};

const mapStateToProps = createStructuredSelector({
    modal: uiSelectors.getModalById(MODALS.ROLE_PARTNER_MODAL),
    userId: userSelectors.getUserId,
});

const mapDispatchToProps = {
    closeModal: uiActions.closeModal,
    openModal: uiActions.openModal,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RolePartnerModal));
